import { useQuery } from '@tanstack/react-query';
import { apiJson } from '@lib/apiClient';
import type { IntakeConfig } from '@/types/intake';

/** Read the per-campaign intake config (result buttons, photo/override rules) from the API. */
export function useIntakeConfig(campaign: string) {
  return useQuery({
    queryKey: ['intake-config', campaign],
    queryFn: () => apiJson<IntakeConfig>(`/api/intake/config?campaign=${encodeURIComponent(campaign)}`),
    staleTime: 5 * 60_000,
  });
}
